import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const periodosHomologacaoRoutes: Routes = [
  {
    path: 'periodos-homologacao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gerenciar Períodos de Homologação',
      breadcrumb: [{ label: 'Períodos de Homologação', url: '/periodos-homologacao' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./periodos-homologacao.component').then(
            (m) => m.PeriodosHomologacaoComponent,
          ),
        data: {
          title: 'Gerenciar Períodos de Homologação',
          roles: [Role.PERIODO_HOMOLOGACAO_CONSULTAR],
          breadcrumb: [{ label: 'Períodos de Homologação', url: '/periodos-homologacao' }],
        },
      },
      {
        path: 'abrir/ciclo',
        loadComponent: () =>
          import('./abrir-periodo/abrir-periodo.component').then(
            (m) => m.AbrirPeriodoComponent,
          ),
        data: {
          title: 'Abrir Período de Homologação - Por Ciclo',
          tipo: 'ciclo',
          roles: [Role.PERIODO_HOMOLOGACAO_GERENCIAR],
          breadcrumb: [
            { label: 'Períodos de Homologação', url: '/periodos-homologacao' },
            { label: 'Abrir Período - Ciclo' },
          ],
        },
      },
      {
        path: 'abrir/area',
        loadComponent: () =>
          import('./abrir-periodo/abrir-periodo.component').then(
            (m) => m.AbrirPeriodoComponent,
          ),
        data: {
          title: 'Abrir Período de Homologação - Por Município',
          tipo: 'area',
          roles: [Role.PERIODO_HOMOLOGACAO_GERENCIAR],
          breadcrumb: [
            { label: 'Períodos de Homologação', url: '/periodos-homologacao' },
            { label: 'Abrir Período - Município' },
          ],
        },
      },
      {
        path: 'abrir/profissional',
        loadComponent: () =>
          import('./abrir-periodo/abrir-periodo.component').then(
            (m) => m.AbrirPeriodoComponent,
          ),
        data: {
          title: 'Abrir Período de Homologação - Por Profissional',
          tipo: 'profissional',
          roles: [Role.PERIODO_HOMOLOGACAO_GERENCIAR],
          breadcrumb: [
            { label: 'Períodos de Homologação', url: '/periodos-homologacao' },
            { label: 'Abrir Período - Profissional' },
          ],
        },
      },
      {
        path: ':id/editar/:tipo',
        loadComponent: () =>
          import('./editar-periodo/editar-periodo.component').then(
            (m) => m.EditarPeriodoComponent,
          ),
        data: {
          title: 'Editar Período de Homologação',
          roles: [Role.PERIODO_HOMOLOGACAO_GERENCIAR],
          breadcrumb: [
            { label: 'Períodos de Homologação', url: '/periodos-homologacao' },
            { label: 'Editar Período' },
          ],
        },
      },
      {
        path: ':id/visualizar',
        loadComponent: () =>
          import('./visualizar-periodo/visualizar-periodo.component').then(
            (m) => m.VisualizarPeriodoComponent,
          ),
        data: {
          title: 'Visualizar Período de Homologação',
          roles: [Role.PERIODO_HOMOLOGACAO_CONSULTAR],
          breadcrumb: [
            { label: 'Períodos de Homologação', url: '/periodos-homologacao' },
            { label: 'Visualizar Período' },
          ],
        },
      },
    ],
  },
];
